import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7piiqmq04r: FaireBrandEntity = {
  token: "b_7piiqmq04r",
  type: "brand",
  name: "Lake & Oak Tea Co.",
  avatarUrl: "https://cdn.faire.com/fastly/1cb40204db8bd8dcd88e46032349e8b8de59566b455b09082686db30c577fd8a.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/4e148f2398ab6500da777278fa6684695e65bc3aa800c0b986263eb0bc137169.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/1cb40204db8bd8dcd88e46032349e8b8de59566b455b09082686db30c577fd8a.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/4e148f2398ab6500da777278fa6684695e65bc3aa800c0b986263eb0bc137169.jpeg",
  location: "Hamilton, ON, CAN",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 146,
  isInsider: false,
  description: "Lake & Oak Tea Co. is a female-powered Canadian wellness brand obsessed with fostering self-care rituals that taste as good as they feel. We're known for our clean and functional Superfood Tea & Adaptogen Blends that also happen to be the *best* you've ever tasted. Things you'll never find in our blends? Sugar, sweeteners or so-called \"natural flavours\" - we let the plants speak for themselves. Vegan, Organic, Sugar-Free and Made with Recyclable Packaging. 2% Goes Back to Mental Health.",
  meta: {
    source: "api",
    importedAt: "2026-09-07T18:42:46.990Z",
    importedBy: "entity-db-cli"
  }
};
